import { Flex, Heading, SimpleGrid, Text } from '@chakra-ui/layout';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useCoursesOfTheDay } from '../../../hooks/useCourses';
import { LoadingPage } from '../../util-pages/LoadingPage';
import { CourseItem } from './CourseItem';

interface UpcomingCoursesIframeProps {
  target?: string;
}

export const UpcomingCoursesIframe: React.FC<UpcomingCoursesIframeProps> = ({
  target,
}) => {
  const courses = useCoursesOfTheDay('', true, true);

  useEffect(() => {
    let height: number;

    const sendPostMessage = () => {
      if (height !== document.getElementById('frameWrapper')?.offsetHeight) {
        height = document.getElementById('frameWrapper')?.offsetHeight || 0;
        window.parent.postMessage(
          {
            frameHeight: height,
          },
          '*'
        );
      }
    };

    window.addEventListener('load', () => sendPostMessage());
    window.addEventListener('resize', () => sendPostMessage());

    if (courses) {
      sendPostMessage();
    }

    return () => {
      window.removeEventListener('load', () => sendPostMessage());
      window.removeEventListener('resize', () => sendPostMessage());
    };
  }, [window, courses]);

  if (!courses.courses || !courses.config) return <LoadingPage />;

  return (
    <SimpleGrid
      id="frameWrapper"
      columns={[1, 1, 7]}
      gap={2}
      fontFamily="unset"
      height="100%"
      overflow="hidden"
    >
      {courses.courses.map((weekday) => (
        <Flex key={weekday.id} direction="column">
          <Heading size="sm" mb={4}>
            {moment(weekday.date).format('dd, DD.MM.')}
          </Heading>
          {weekday.courses && weekday.courses.length > 0 ? (
            weekday.courses.map((course) => (
              <CourseItem
                config={courses.config}
                key={course.uid}
                course={course}
                target={target}
              />
            ))
          ) : (
            <Text>An diesem Tag sind keine Kurse geplant</Text>
          )}
        </Flex>
      ))}
    </SimpleGrid>
  );
};
